export default "__VITE_ASSET__BHTeqrY___"